import React from "react";
import PropTypes from "prop-types";
import withCustomStyles from "./SimpleDialogPart.style";
import { ANDROID_APP_LINK, IOS_APP_LINK } from "../constatns/AppConstants";
import gtmService from "../services/GTMService";
import { GButton, GDialog } from "./ui";

// Generic dialog kept for existing callers. Built on GDialog (bottom sheet on
// phones). `confirmationDialogue` marks the accept action as destructive.
const SimpleDialogPart = props => {
  const {
    classes,
    onClose,
    open,
    title,
    content,
    confirmationDialogue,
    disabled,
    isDownloadLinks,
    cancelBtnContent,
    acceptBtnContent,
    onAccept,
    onCancel,
    children
  } = props;

  const trackClickEvent = platform => {
    gtmService.event("User", `Goto ${platform}`);
  };

  const actions =
    acceptBtnContent || cancelBtnContent ? (
      <>
        {cancelBtnContent && (
          <GButton variant="secondary" onClick={onCancel} disabled={disabled}>
            {cancelBtnContent}
          </GButton>
        )}
        {acceptBtnContent && (
          <GButton
            variant={confirmationDialogue ? "destructive" : "primary"}
            onClick={onAccept}
            disabled={disabled}
          >
            {acceptBtnContent}
          </GButton>
        )}
      </>
    ) : null;

  return (
    <GDialog
      open={Boolean(open)}
      onClose={onClose}
      title={title}
      actions={actions}
    >
      {content && <p className={classes.content}>{content}</p>}
      {children}
      {isDownloadLinks && (
        <p className={classes.downloadLinks}>
          Or use our{" "}
          <a
            href={ANDROID_APP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClickEvent("android")}
          >
            Android
          </a>{" "}
          or{" "}
          <a
            href={IOS_APP_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClickEvent("ios")}
          >
            iOS
          </a>{" "}
          app for the full experience.
        </p>
      )}
    </GDialog>
  );
};

SimpleDialogPart.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.node,
  content: PropTypes.node,
  confirmationDialogue: PropTypes.bool,
  disabled: PropTypes.bool,
  isDownloadLinks: PropTypes.bool,
  cancelBtnContent: PropTypes.node,
  acceptBtnContent: PropTypes.node,
  onAccept: PropTypes.func,
  onCancel: PropTypes.func
};

SimpleDialogPart.defaultProps = {
  isDownloadLinks: false
};

export default withCustomStyles(SimpleDialogPart);
